import { useCallback } from 'react'
import { DropdownItem } from '@/forms-legacy'
import { useRecurrenceDispatch } from '../../../../../providers/StateProvider'
import { type UpdateRecurrenceEndAction } from '../../../../../types'

export function useOnChange() {
  const dispatch = useRecurrenceDispatch()

  return useCallback(
    (items: DropdownItem[]) => {
      if (items.length > 0) {
        const { id } = items[0]
        dispatch({
          type: 'recurrenceEnd:change',
          recurrenceEnd: {
            endType: id as UpdateRecurrenceEndAction['recurrenceEnd']['endType'],
          },
        })
      }
    },
    [dispatch],
  )
}
